module.exports = __webpack_public_path__ + "img/logo.583c0bd9.png";